/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionParameterDtoValueType } from './CreateDefinitionParameterDtoValueType';
import {
    CreateDefinitionParameterDtoValueTypeFromJSON,
    CreateDefinitionParameterDtoValueTypeFromJSONTyped,
    CreateDefinitionParameterDtoValueTypeToJSON,
} from './CreateDefinitionParameterDtoValueType';
import type { GeometryLabelDto } from './GeometryLabelDto';
import {
    GeometryLabelDtoFromJSON,
    GeometryLabelDtoFromJSONTyped,
    GeometryLabelDtoToJSON,
} from './GeometryLabelDto';
import type { RtSystemQuantityScopeDto } from './RtSystemQuantityScopeDto';
import {
    RtSystemQuantityScopeDtoFromJSON,
    RtSystemQuantityScopeDtoFromJSONTyped,
    RtSystemQuantityScopeDtoToJSON,
} from './RtSystemQuantityScopeDto';

/**
 * 
 * @export
 * @interface CreateSetupQuantityUsageDto
 */
export interface CreateSetupQuantityUsageDto {
    /**
     * 
     * @type {CreateDefinitionParameterDtoValueType}
     * @memberof CreateSetupQuantityUsageDto
     */
    valueType?: CreateDefinitionParameterDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSetupQuantityUsageDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSetupQuantityUsageDto
     */
    inputRangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSetupQuantityUsageDto
     */
    inputRangeMax?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSetupQuantityUsageDto
     */
    unitId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSetupQuantityUsageDto
     */
    isUsageEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSetupQuantityUsageDto
     */
    useSetupGeometry?: boolean;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof CreateSetupQuantityUsageDto
     */
    medicalSystemScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof CreateSetupQuantityUsageDto
     */
    qaEquipmentScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<GeometryLabelDto>}
     * @memberof CreateSetupQuantityUsageDto
     */
    setupGeometries?: Array<GeometryLabelDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSetupQuantityUsageDto
     */
    $type?: CreateSetupQuantityUsageDtoTypeEnum;
}


/**
 * @export
 */
export const CreateSetupQuantityUsageDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateSetupQuantityUsageDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateSetupQuantityUsageDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateSetupQuantityUsageDtoTypeEnum = typeof CreateSetupQuantityUsageDtoTypeEnum[keyof typeof CreateSetupQuantityUsageDtoTypeEnum];


/**
 * Check if a given object implements the CreateSetupQuantityUsageDto interface.
 */
export function instanceOfCreateSetupQuantityUsageDto(value?: unknown): value is CreateSetupQuantityUsageDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateSetupQuantityUsageDtoTypeEnum)[0];
}

export function CreateSetupQuantityUsageDtoFromJSON(json: any): CreateSetupQuantityUsageDto {
    return CreateSetupQuantityUsageDtoFromJSONTyped(json, false);
}

export function CreateSetupQuantityUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSetupQuantityUsageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionParameterDtoValueTypeFromJSON(json['valueType']),
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'inputRangeMin': !exists(json, 'inputRangeMin') ? undefined : json['inputRangeMin'],
        'inputRangeMax': !exists(json, 'inputRangeMax') ? undefined : json['inputRangeMax'],
        'unitId': !exists(json, 'unitId') ? undefined : json['unitId'],
        'isUsageEnabled': !exists(json, 'isUsageEnabled') ? undefined : json['isUsageEnabled'],
        'useSetupGeometry': !exists(json, 'useSetupGeometry') ? undefined : json['useSetupGeometry'],
        'medicalSystemScope': !exists(json, 'medicalSystemScope') ? undefined : (json['medicalSystemScope'] === null ? null : (json['medicalSystemScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'qaEquipmentScope': !exists(json, 'qaEquipmentScope') ? undefined : (json['qaEquipmentScope'] === null ? null : (json['qaEquipmentScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'setupGeometries': !exists(json, 'setupGeometries') ? undefined : (json['setupGeometries'] === null ? null : (json['setupGeometries'] as Array<any>).map(GeometryLabelDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateSetupQuantityUsageDtoToJSON(value?: CreateSetupQuantityUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'valueType': CreateDefinitionParameterDtoValueTypeToJSON(value.valueType),
        'decimalPlaces': value.decimalPlaces,
        'inputRangeMin': value.inputRangeMin,
        'inputRangeMax': value.inputRangeMax,
        'unitId': value.unitId,
        'isUsageEnabled': value.isUsageEnabled,
        'useSetupGeometry': value.useSetupGeometry,
        'medicalSystemScope': value.medicalSystemScope === undefined ? undefined : (value.medicalSystemScope === null ? null : (value.medicalSystemScope as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'qaEquipmentScope': value.qaEquipmentScope === undefined ? undefined : (value.qaEquipmentScope === null ? null : (value.qaEquipmentScope as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'setupGeometries': value.setupGeometries === undefined ? undefined : (value.setupGeometries === null ? null : (value.setupGeometries as Array<any>).map(GeometryLabelDtoToJSON)),
        '$type': value.$type,
    });
}

